import { useMutation } from '@gogame/query';

import { createPostback } from 'scenes/Integrations/sources/postbacks/postbacks';

import { createPostback as create } from '../queryKeyFactory';
import { errorMessageGetter } from './errorMessageGetter';

export const useCreatePostback = () => {
  const createMutation = useMutation(create(), createPostback, {
    refresh: true,
    successMessage: () => 'Integration Created',
    errorMessage: errorMessageGetter,
  });
  return [createMutation.mutateAsync, createMutation];
};
